export class InvoicePayment {
  public PaymentID: number = 0;
  public PaymentHeaderID: number = 0;
  public InvoiceNumber: number = 0;
  public InvoiceLineItemID: number = 0;
  public AppliedFromUnappliedPaymentID: number = 0;
  public ProfileID: number = 0;
  public PaymentDate: Date = new Date();
  public ApplyDate: Date = new Date();
  public PaymentTypeID: number = 0;
  public PaymentType: string = '';
  public Amount: number = 0;
  public Refno: string = '';
  public CheckNum: string = '';
  public Notes: string = '';
  public DateCreated: Date = new Date();
  public DateChanged: Date = new Date();
  public ChangedBy: string = '';
  public Posted: boolean = false;
  public DatePosted: Date = new Date();
  public Batch_Creation: string = '';
  public Batch_Posting: string = '';
  public PaymentSource: string = '';
  public CC_CreditCardNum: string = '';
  public CC_ValidThrough: string = '';
  public CC_NameOnCard: string = '';
  public CC_BillingAddress1: string = '';
  public CC_BillingAddress2: string = '';
  public CC_BillingCity: string = '';
  public CC_BillingState: string = '';
  public CC_BillingZip: string = '';
  public CC_BillingZipExt: string = '';
  public CC_PIN: string = '';
  public CC_PhoneNum: string = '';
  public PostedBy: string = '';
}
